import React, { useRef, useEffect, useState } from "react";
import Select from "react-select";
import "../utils/FilterMenu.css";
import api from "../../api";

const SalesFilterMenu = ({ filters, setFilters, onClose }) => {
  const menuRef = useRef(null);
  const [peopleStatuses, setPeopleStatuses] = useState([]);
  
  // Fetch available statuses from people table
  useEffect(() => {
    const fetchPeopleStatuses = async () => {
      try {
        const response = await api.get('/people');
        // Extract unique statuses from people
        const uniqueStatuses = [...new Set(response.data
          .map(person => person.status)
          .filter(status => status)) // Filter out null/undefined/empty
        ];
        setPeopleStatuses(uniqueStatuses);
      } catch (error) {
        console.error("Error fetching people statuses:", error);
        setPeopleStatuses(["New", "Contacted", "Qualified", "Nurturing", "Unqualified"]); // Fallback values
      }
    };
    
    fetchPeopleStatuses();
  }, []);
  
  const statusOptions = peopleStatuses.map((status) => ({
    value: status,
    label: status,
  }));

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    // Add event listener when component mounts
    document.addEventListener("mousedown", handleClickOutside);
    
    // Clean up event listener when component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const handleApply = () => {
    onClose();
  };

  const handleCancel = () => {
    // Reset filters to their previous values
    setFilters(prev => ({
      ...prev,
      statuses: []
    }));
    onClose();
  };

  return (
    <div className="mass-reassign-menu filter-menu" ref={menuRef}>
      <h3>Filter Sales</h3>
      <div className="filter-control">
        <label>Status:</label>
        <Select
          isMulti
          options={statusOptions}
          value={statusOptions.filter((option) =>
            filters.statuses.includes(option.value)
          )}
          onChange={(selected) =>
            setFilters({
              ...filters,
              statuses: selected ? selected.map((s) => s.value) : [],
            })
          }
          placeholder="Select statuses..."
        />
      </div>
      <div className="actions">
        <button onClick={handleApply}>Apply</button>
        <button onClick={handleCancel} style={{ backgroundColor: "#6c757d" }}>Cancel</button>
      </div>
    </div>
  );
};

export default SalesFilterMenu; 